export default {
	init() {
    // Filtering

    // const rating = document.getElementById('rating');
    // const elements = document.querySelectorAll('.tabs-title');
    // rating.addEventListener('change', () => {
    //   let value = rating.value;
    //   elements.forEach((el) => {
    //     if (value === '') {
    //       el.classList.remove('hidden');
    //     } else {
    //       const rating = el.dataset.cats;
    //       if (!rating || rating.includes(value)) {
    //         el.classList.remove("hidden");
    //       } else {
    //         el.classList.add("hidden");
    //       }
    //     }
    //   })
    // })

    let links = $('.txt-link');
    links.removeAttr('role');
    links.removeAttr('aria-controls');
    links.removeAttr('aria-selected');
    links.removeAttr('id');
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js